import { Textarea } from "@/components/ui/textarea";

interface InlineNoteInputProps {
  value: string;
  onChange: (value: string) => void;
}

export function InlineNoteInput({ value, onChange }: InlineNoteInputProps) {
  return (
    <Textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Add a note..."
      rows={3}
      className="text-xs h-auto resize-none"
    />
  );
}
